import { styled } from 'styled-components';

import { scrolledDownVisibleVar, scrolledDownZeroVar } from '#/theme/scrolled';
import { colors, cssBreakpoints, spacing, transition } from '#/theme/theme';

import { SEARCH_RESULTS_FIXED_HEADER_HEIGHT } from './searchResultsHeaderConstants';

export const SearchResultsHeaderHolder = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 41px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-bottom: ${spacing[24]};
  }

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: var(${scrolledDownVisibleVar}, 'hidden');
    transition: transform ${transition};
    height: ${SEARCH_RESULTS_FIXED_HEADER_HEIGHT};
    transform: translateY(calc(var(${scrolledDownZeroVar}, 1) * 100%));
    z-index: 10;
    background: ${colors.white};
    padding: 0 ${spacing[16]};
    box-shadow: 0 -3px 4px 1px rgb(0 0 0 / 0.15);
  }
`;

export const SearchResultsHeaderLeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const SearchResultsHeaderLeftSideSort = styled.div`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const SearchResultsHeaderRightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SearchResultsHeaderPostAListingHolder = styled.div`
  @media all and (max-width: ${cssBreakpoints.smDown}) {
    display: none;
  }
`;
